import React from 'react';
import { Dialog, BUTTON_VARIANTS } from 'cdk-radial';
import { useTranslation } from 'react-i18next';

interface Props {
    isOpen: boolean;
    appName: string;
    scenario: 'set' | 'remove' | 'update';
    previousDefaultAppName: string;
    onConfirm: () => void;
    onDismiss: () => void;
}

export default function SetStartupAppDialog({
    isOpen,
    appName,
    scenario,
    previousDefaultAppName,
    onConfirm,
    onDismiss,
}: Props) {
    const { t } = useTranslation();

    const scenarioConfig = {
        set: {
            title: t('baseCard.startupApp.setTitle'),
            confirmLabel: t('baseCard.startupApp.setConfirm'),
            line1: <><strong>{appName}</strong> {t('baseCard.startupApp.setContent1')}</>,
        },
        remove: {
            title: t('baseCard.startupApp.removeTitle'),
            confirmLabel: t('baseCard.startupApp.removeConfirm'),
            line1: <><strong>{appName}</strong> {t('baseCard.startupApp.removeContent1')}</>,
        },
        update: {
            title: t('baseCard.startupApp.updateTitle'),
            confirmLabel: t('baseCard.startupApp.updateConfirm'),
            line1: (
                <>
                    <strong>{appName}</strong>{' '}
                    {t('baseCard.startupApp.updateContent1a')}{' '}
                    <strong>{previousDefaultAppName}</strong>{' '}
                    {t('baseCard.startupApp.updateContent1b')}
                </>
            ),
        },
    };

    const { title, confirmLabel, line1 } = scenarioConfig[scenario];

    return (
        <Dialog
            id="startup-app-dialog"
            isOpen={isOpen}
            onClose={onDismiss}
            title={title}
            dataTestId="startup-app-dialog"
            buttonsProps={[
                {
                    id: 'startup-dismiss',
                    text: t('common.cancel'),
                    variant: BUTTON_VARIANTS.TEXT,
                    onClick: onDismiss,
                },
                {
                    id: 'startup-confirm',
                    text: confirmLabel,
                    variant: BUTTON_VARIANTS.TEXT,
                    onClick: onConfirm,
                },
            ]}
        >
            <ul style={{ margin: '8px 0', paddingLeft: '20px' }}>
                <li style={{ marginBottom: '8px' }}>{line1}</li>
                <li>{t('baseCard.startupApp.content2')}</li>
            </ul>
        </Dialog>
    );
}